import 'core-js/features/dom-collections/for-each';
import 'core-js/features/promise';

/* Object.assign polyfill */
if (typeof Object.assign != 'function') {
    Object.assign = function(target) {
        'use strict';
        if (target == null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        target = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source != null) {
                for (var key in source) {
                    if (Object.prototype.hasOwnProperty.call(source, key)) {
                        target[key] = source[key];
                    }
                }
            }
        }
        return target;
    };
}

export default (el) => {
    el.querySelectorAll('[data-component]').forEach((el) => {
        import('../' + el.dataset.component + '.js').then((component) => {
            component.default(el);
        });
    });
};
